 export default class MathExtensions {
    public static lerp(v0: number, v1: number, t: number): number {
        return v0 * (1 - t) + v1 * t;
    }
    
    public static normalize(x:number, max:number, min:number):number {
        return (x - min) / (max - min);
    }
}